import LoginForm from '../../components/login/LoginForm';
import { useAuthStore } from '../../stores/auth/auth.store';
import { useUIStore } from '../../stores/ui/ui.store';

const LoginPage = () => {
  const { loading } = useUIStore((state) => state);
  const { login } = useAuthStore((state) => state);
  const loginHandler = async (user: string, password: string) => {
    await login(user, password);
  };

  return <LoginForm onClick={loginHandler} isLoading={loading} />;
};

export default LoginPage;
